import React from "react";
import img1 from "../../../Assets/Home/PI.jpg";
import logo from "../../../Assets/Logos/w-logo.png";
import { useNavigate } from "react-router-dom";

// Decorative wavy line SVG for dark side
const WavyLines = () => (
  <svg
    className="absolute inset-0 w-full h-full"
    viewBox="0 0 540 420"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-20,80 Q60,40 140,90 Q220,140 300,80 Q380,20 460,70 Q520,105 560,80"
      stroke="#2a0a08"
      strokeWidth="55"
      fill="none"
      opacity="0.6"
    />
    <path
      d="M-20,220 Q80,170 180,230 Q270,280 380,215 Q460,165 580,210"
      stroke="#200806"
      strokeWidth="45"
      fill="none"
      opacity="0.5"
    />
    <path
      d="M-20,350 Q100,300 220,360 Q320,410 440,345 Q500,308 580,340"
      stroke="#250a06"
      strokeWidth="40"
      fill="none"
      opacity="0.45"
    />
  </svg>
);

export default function MinemoCTA() {
  const navigate = useNavigate();
  return (
    <div
      className="w-full flex flex-col lg:flex-row"
      style={{ fontFamily: "'Barlow', 'Montserrat', sans-serif" }}
    >
      {/* Left dark panel */}
      <div
        className="relative flex flex-col justify-between px-4 sm:px-8 md:px-12 lg:px-32 py-8 sm:py-10 md:py-12 overflow-hidden w-full lg:w-[74%]"
        style={{
          background:
            "radial-gradient(ellipse at 20% 40%, #2a0805 0%, #0a0404 60%, #000 100%)",
          minHeight: "380px",
        }}
      >
        {/* Wavy decorative lines */}
        <WavyLines />

        {/* Content */}
        <div className="relative z-10">
          {/* Red asterisk */}
          <div
            className="text-[#e8341c] font-black mb-4 sm:mb-5 md:mb-6 leading-none select-none"
            style={{ fontSize: "clamp(32px, 5vw, 52px)", lineHeight: 1 }}
          >
            ✳
          </div>

          {/* Heading */}
          <h2
            className="text-white font-extrabold leading-tight mb-2"
            style={{
              fontSize: "clamp(24px, 5vw, 60px)",
              letterSpacing: "0.02em",
              lineHeight: 1.08,
            }}
          >
            More About Our <br className="hidden xs:block" />
            <span
              className="text-[#e8341c]"
              style={{
                textDecoration: "underline",
                textDecorationColor: "#e8341c",
                textUnderlineOffset: "4px sm:6px",
              }}
            >
              Company
            </span>
          </h2>

          {/* Description */}
          <p className="text-[#F8F8F2] leading-relaxed tracking-wide mt-4 sm:mt-6 md:mt-8 text-xs sm:text-sm md:text-base max-w-3xl">
            What sets Prudence apart is our fusion of cutting-edge technology
            with in-house execution power. Nominated for India's 5000 Best MSME
            Awards 2024, we bridge scale and precision, ensuring projects meet
            stringent quality benchmarks while supporting local communities
            through CSR initiatives. Whether supplying aggregates for national
            highways or optimizing quarry yields, we turn geological potential
            into measurable results.
          </p>
        </div>

        {/* Contact button and logo */}
        <div className="relative z-10 mt-6 sm:mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
          <button
            onClick={() => {
              navigate("/contact");
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
            className="border border-white/60 text-white text-xs sm:text-sm font-bold tracking-[0.16em] uppercase px-5 sm:px-6 md:px-7 py-2.5 sm:py-3 rounded hover:bg-white hover:text-black transition-all duration-200 w-full sm:w-auto text-center"
            style={{ letterSpacing: "0.16em" }}
          >
            CONTACT US
          </button>

          {/* Logo - repositioned for mobile */}
          <img
            src={logo}
            alt="Prudence India Logo"
            className="w-32 sm:w-40 md:w-48 lg:w-52 h-auto object-contain sm:absolute sm:-bottom-10 sm:-right-12 lg:-right-24 mt-4 sm:mt-0 self-center sm:self-auto"
          />
        </div>
      </div>

      {/* Right image panel */}
      <div
        className="relative overflow-hidden w-full lg:w-[46%]"
        style={{ minHeight: "400px" }}
      >
        <div className="w-full h-full">
          <img
            src={img1}
            alt="Prudence India Mining Operations"
            className="object-cover w-full h-[400px] sm:h-[450px] md:h-[500px] lg:h-[540px]"
          />
        </div>

        {/* Diagonal red banner - responsive positioning */}
        <div
          className="absolute flex items-center overflow-hidden"
          style={{
            bottom: "clamp(80px, 15vw, 180px)",
            right: "-38px",
            background: "#e8341c",
            transform: "rotate(-33deg)",
            transformOrigin: "right bottom",
            minWidth: "500px",
            width: "140%",
          }}
        >
          <div className="flex animate-marquee w-max h-[40px]">
            {[...Array(12)].map((_, i) => (
              <span
                key={i}
                className="text-white font-black text-lg tracking-widest font-krona px-8 mt-2 whitespace-nowrap"
              >
                ✳ PRUDENCE INDIA ✳ PRUDENCE INDIA ✳
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
